<template>
    <label
        class="WSwitch"
        :class="[color, { error, disabled }]"
    >
        <input
            :id="id"
            :checked="value"
            :name="name"
            :disabled="disabled"
            :class="['Input', inputStyles]"
            type="checkbox"
            v-on="inputListeners"
        >
        <span class="Slider" />
    </label>
</template>

<script>
import VueTypes from 'vue-types'
import { merge } from 'lodash'
import { generateIdMixin } from '@/mixins'

export default {
    name: 'WSwitch',
    mixins: [generateIdMixin],
    props: {
        value: VueTypes.bool.isRequired,
        name: VueTypes.string.isRequired,
        color: VueTypes.oneOf(['primary', 'secondary', '']).def('secondary'),
        error: VueTypes.bool.def(false),
        disabled: VueTypes.bool.def(false),
    },
    computed: {
        inputListeners () {
            return merge({}, this.$listeners, {
                input: (event) => {
                    this.$emit('input', event.target.checked)
                },
            })
        },
        inputStyles () {
            return { checked: this.value }
        },
    },
}
</script>

<style scoped lang="scss">
.WSwitch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 24px;

    input {
        opacity: 0;
        width: 0;
        height: 0;

        &:checked:not(.disabled) {
            & + .Slider {
                background-color: $secondary;

                &:before {
                    transform: translateX(16px);
                }
            }
        }

        &:focus + .Slider {
            box-shadow: 0 0 1px $secondary;
        }
    }

    .Slider {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 34px;
        background-color: $form-switch-bg;
        transition: .15s ease-out;
        cursor: pointer;

        &:before {
            position: absolute;
            content: "";
            height: 20px;
            width: 20px;
            left: 2px;
            bottom: 2px;
            border-radius: 50%;
            background-color: $white;
            transition: .15s ease-out;
        }
    }

    &.primary {
        input {
            &:checked + .Slider {
                background-color: $accent-blue;
            }

            &:focus + .Slider {
                box-shadow: 0 0 1px $primary;
            }
        }
    }

    &.secondary {
        input {
            &:checked + .Slider {
                background-color: $secondary;
            }

            &:focus + .Slider {
                box-shadow: 0 0 1px $secondary;
            }
        }
    }

    &.error {
        input {
            &:checked + .Slider {
                background-color: $danger;
            }

            &:focus + .Slider {
                box-shadow: 0 0 1px $danger;
            }
        }
    }

    &.disabled {
        input {
            &:checked + .Slider {
                opacity: .3;
            }
            &:focus + .Slider {
                opacity: .3;
            }
        }
    }
}
</style>
